define((require) => {
    "use strict";

    var $            = require("jquery"),
        Browser      = require("shared/services/Browser"),
        ImprovedView = require("editor/zbone/ImprovedView"),
        {Logger}     = require("shared/util/Logger"),
        MessageNode  = require("services/messageNode/MessageNode"),
        MessageTypes = require("ui/publish/MessageTypes"),
        template     = require("ui/publish/FramedPublishToolbarView.tpl"),
        UrlUtil      = require("shared/util/UrlUtil"),
        Window       = require("shared/services/Window");

    var ADMIN_MODE_IDENTIFIER = "zmagsCreatorAdminMode=true";

    // Since we are about to open on a customer window, pass through our logging settings...
    var LOG_MODE_IDENTIFIER = "zmagsLog=" + Logger.level();

    /**
     *
     */
    return ImprovedView.extend({

        template: template,

        className: "zmags-framed-publish-toolbar",

        templateHelpers: function() {
            var projectContext = !!this.options.projectId,
                base = projectContext ? "project/" + this.options.projectId + "/" : "";

            return {
                browser:    Browser,
                siteUrl:    UrlUtil.appendParam(UrlUtil.appendParam(this.options.url, ADMIN_MODE_IDENTIFIER), LOG_MODE_IDENTIFIER),
                // timestamp is cache buster since Firefox and IE will not load it otherwise
                toolbarUrl: "?" + new Date().getTime() + "#" + base + "publishtoolbar/" + encodeURIComponent(this.options.url)
            };
        },

        _node: null,

        initialize: function() {
            // Log config: since just an intermediate node, only log if we use verbose log level...
            var logOptions = {log: Logger.level() > Logger.LOG, ignore: MessageTypes.PAGE_IS_CHANNELS_ENABLED};

            // This frame node is just an intermediate relay node, so we do not really care which origins are
            // allowed - this is handled by the "publish", "toolbar", and "channel_admin" nodes explicitly. Also,
            // by allowing all, IE is able to post messages from "channels_admin" to this node, which we can use
            // to open NAVIGATE_TO links, even in case on domain inconsistencies...
            this._node = new MessageNode({name: "frame", log: logOptions, eksport: "__zmags.creator.node"});

            var on = {};

            // Close both pop-up windows if either of them is closed via "Close-button" click...
            on[MessageNode.Message.Actions.LEAVE] = function(message) {
                if (message.data === "self") {
                    window.close();
                }
            };
            // Zendesk does not allow itself to be opened in a frame, and IE will not allow us to open the link directly
            // in another frame, nor by using JS, so we have to update this frame location...
            on[MessageTypes.NAVIGATE_TO] = function(message) {
                Window.open(message.data.url, message.data.target || "zmags_creator");
            };

            this._node.on(on, this);

            // We do not need a nav-bar here...
            $(document).ready(() => {
                $(".navigation-bar").remove();
                $(".main").css("top", "0");
            });
        },

        onClose: function() {
            this._node.close();
            this._node = null;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/publish/FramedPublishToolbarView.js